(function () {
  document.querySelectorAll('[data-sova-tiles]').forEach(function (root) {
    var track = root.querySelector('[data-sova-tiles-track]');
    var prev = root.querySelector('[data-sova-tiles-prev]');
    var next = root.querySelector('[data-sova-tiles-next]');
    if (!track) return;

    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var tile = track.querySelector('.sova-tile');
      if (!tile) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 20;
      return tile.offsetWidth + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* ---------- Auto-scroll ---------- */
    var autoScroll = root.getAttribute('data-auto-scroll') !== 'false';
    var intervalSecs = parseInt(root.getAttribute('data-scroll-interval'), 10) || 5;
    var timer = null;
    var paused = false;

    function advance() {
      if (paused) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= max) {
        track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    function startAuto() {
      if (!autoScroll || reduceMotion || timer) return;
      timer = window.setInterval(advance, intervalSecs * 1000);
    }

    function stopAuto() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (autoScroll && !reduceMotion) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
        root.addEventListener(evt, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (evt) {
        root.addEventListener(evt, function () { paused = false; }, { passive: true });
      });
      root.addEventListener('touchend', function () {
        window.setTimeout(function () { paused = false; }, 4000);
      }, { passive: true });

      [prev, next].forEach(function (btn) {
        if (btn) btn.addEventListener('click', function () {
          paused = true;
          window.setTimeout(function () { paused = false; }, 8000);
        });
      });

      if ('IntersectionObserver' in window) {
        var sectionIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { startAuto(); } else { stopAuto(); }
          });
        }, { threshold: 0.2 });
        sectionIo.observe(root);
      } else {
        startAuto();
      }
    }

    /* ---------- Keyboard support ---------- */
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    });

    /* ---------- Video autoplay when in view ---------- */
    var videos = Array.prototype.slice.call(track.querySelectorAll('video'));

    videos.forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');
    });

    if (autoplay && !reduceMotion && videos.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            var attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5, 1], root: null });

      videos.forEach(function (video) { observer.observe(video); });
    }

    /* ---------- Sound toggle ---------- */
    root.querySelectorAll('[data-sova-tile-sound]').forEach(function (btn) {
      var tile = btn.closest('.sova-tile');
      var video = tile ? tile.querySelector('video') : null;
      if (!video) {
        btn.hidden = true;
        return;
      }

      btn.addEventListener('click', function () {
        var willUnmute = video.muted;

        if (willUnmute) {
          videos.forEach(function (other) {
            if (other !== video) other.muted = true;
          });
          root.querySelectorAll('[data-sova-tile-sound]').forEach(function (other) {
            if (other !== btn) {
              other.setAttribute('aria-pressed', 'false');
              other.setAttribute('aria-label', 'Unmute video');
            }
          });
          paused = true;
        }

        video.muted = !willUnmute;
        btn.setAttribute('aria-pressed', willUnmute ? 'true' : 'false');
        btn.setAttribute('aria-label', willUnmute ? 'Mute video' : 'Unmute video');

        if (willUnmute && video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    });
  });
})();
